/**
 * @ngdoc controllers
 * @memberof mercury.modules.time
 * @name TimeStaffAddPosCtrl
 */
angular.module('mercury.modules.time.staff')
.controller('TimeStaffAddPosCtrl', ["dialog", "$filter", "ReportPosStaff", "$scope", "$state", function(dialog, $filter, ReportPosStaff, $scope, $state) {
  $scope.selected = {};

  $scope.posStaffLoading = ReportPosStaff.getAllActiveUnlinked();
  $scope.posStaffLoading.then(function(posStaff) {
    $scope.posStaff = posStaff;
  });

  $scope.addEmployee = function() {
    dialog.close();
    $state.go('Time.StaffAdd', {posIdentifier: $scope.selected.id});
  };
}]);
